<template>
	<ECommerceAddToCartStickyButton
		:button-texts="content.buttonTexts"
		:feature-to-show="content.featureToShow"
	/>
</template>

<script>
import GizmoComponentMixin from "~/mixins/platform/GizmoComponentMixin.js";

export default defineNuxtComponent({
	name: "GizmoECommerceAddToCartStickyButton",
	mixins: [GizmoComponentMixin],
});
</script>
